import { FEATURE_FLAG__BEGIN_15 } from '../../../../constants/featureflags';
import { generateVariantData } from '../../../../experiments/utils';
import HeroDefault from './HeroDefault';
import HeroQuiz from './HeroQuiz';
import HeroRedesign from './HeroRedesign';

const imgURL = process.env.REACT_APP_CLOUDFRONT_URL;
const CTA_ID = 2;

const redesignData = {
  component: HeroRedesign,
  data: {
    title: 'Unlock your child’s future with code',
    valueProps: [
      'Kids create their own games in just 1 week!',
      'Learn to code through our classes & award-winning app',
      'Boost creativity, problem solving, & communication skills',
    ],
    valuePropIcon: `${imgURL}/accounts/checkmark_dark_blue.svg`,
    heroImageDesktop: `${imgURL}/flagship/home-page/hero_image_redesign_winter.png`,
    heroImageMobile: `${imgURL}/flagship/home-page/hero_image_redesign_winter.png`,
    ctaLabel: 'TRY FOR FREE',
    trialText: 'Cancel anytime',
  },
  ctaId: 'section_hero',
};
const redesignWithGenericHero = {
  ...redesignData,
  data: {
    ...redesignData.data,
    ctaLabel: 'Start Your 7-Day Free Trial',
    heroImageDesktop: `${imgURL}/flagship/home-page/hero_image_3-10.png`,
    heroImageMobile: `${imgURL}/flagship/home-page/hero_image_3-10.png`,
  },
};

const variantToHeroMapping = {
  quizHero: {
    component: HeroQuiz,
    data: {
      title: 'Screen time you can feel good about.',
      ctaLabel: 'START QUIZ',
      heroImageDesktop: `${imgURL}/flagship/home-page/hero_image.png`,
      heroImageMobile: `${imgURL}/flagship/home-page/hero_image.png`,
    },
    ctaId: CTA_ID,
  },
  homepageRedesign: redesignData,
  premiumOndemandClasses: redesignWithGenericHero,
  premiumVsStandardDesign: redesignWithGenericHero,
  premiumOndemandClassesTrials: redesignWithGenericHero,
  base: {
    component: HeroDefault,
    data: {
      title: 'Screen time you can feel good about.',
      valueProps: [
        '<strong>Learn REAL code</strong> through our proprietary game making platform',
        '<strong>Learn how to problem solve</strong> using the game design process',
        '<strong>Accelerate STEM development</strong> by letting kids do what they love',
      ],
      valuePropIcon: `${imgURL}/global/icons/checkmark-white.svg`,
      heroImageDesktop: `${imgURL}/accounts/HeroImg-generic.jpg`,
      heroImageMobile: `${imgURL}/accounts/HeroImg-generic.jpg`,
      ctaLabel: 'TRY FOR FREE',
      trialText: 'Cancel anytime',
    },
    ctaId: CTA_ID,
  },
  [FEATURE_FLAG__BEGIN_15]: {
    ...redesignWithGenericHero,
    data: {
      ...redesignWithGenericHero.data,
      heroImageDesktop: `${imgURL}/flagship/home-page/hero_bw15_desktop.png`,
      heroImageMobile: `${imgURL}/flagship/home-page/hero_bw15_mobile.png`,
    },
  },
};

export const getHeroVariantData = generateVariantData(variantToHeroMapping);



// WEBPACK FOOTER //
// ./src/containers/Home/sections/Hero/heroData.js